import { render, staticRenderFns } from "./SkupTemaForma.vue?vue&type=template&id=c63fe7f0&scoped=true&"
import script from "./SkupTemaForma.vue?vue&type=script&lang=js&"
export * from "./SkupTemaForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63fe7f0",
  null
  
)

export default component.exports